import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DayKeys } from '@app/enums';
import { ScheduleBase } from '@app/reducers/orm/schedule/schedule.model';
import { _, TranslateService } from '@ngx-translate/core';

// needed for translation extraction
const WEEK_DAYS: { key: DayKeys; label: string }[] = [
  { key: DayKeys.MONDAY, label: _('Mo') },
  { key: DayKeys.TUESDAY, label: _('Tu') },
  { key: DayKeys.WEDNESDAY, label: _('We') },
  { key: DayKeys.THURSDAY, label: _('Th') },
  { key: DayKeys.FRIDAY, label: _('Fr') },
  { key: DayKeys.SATURDAY, label: _('Sa') },
  { key: DayKeys.SUNDAY, label: _('Su') },
];

@Pipe({
  name: 'recurringScheduleHtml',
})
export class RecurringScheduleHtmlPipe implements PipeTransform {
  private translate = inject(TranslateService);
  private sanitizer = inject(DomSanitizer);

  transform(schedule: ScheduleBase): SafeHtml | null {
    if (schedule?.interval) {
      const base =
        schedule.interval === '1'
          ? this.translate.instant('Every week on')
          : this.translate.instant('Every {{interval}} weeks on', { interval: schedule.interval });

      return this.sanitizer.bypassSecurityTrustHtml(
        `${base}:
          <br/>${WEEK_DAYS.filter((day) => schedule[day.key])
            .map((day) => this.translate.instant(day.label))
            .join(', ')}`,
      );
    }
    return null;
  }
}
